import { computed } from 'vue';
import type { User } from '../types/UsersFilterData';

export function useUserGrouping(users: User[]) {
    const groupedAndSortedUsers = computed(() => {
        // Sort by team name first, then by user name
        const sortedUsers = [...users].sort((a, b) => {
            const aTeamName = a.teamName || 'No Team';
            const bTeamName = b.teamName || 'No Team';
            
            const teamComparison = aTeamName.localeCompare(bTeamName);
            if (teamComparison !== 0) return teamComparison;
      
            // Combine firstName and lastName for sorting
            const aName = `${a.firstName} ${a.lastName}`;
            const bName = `${b.firstName} ${b.lastName}`;
            return aName.localeCompare(bName);
        });

        // Group by team name
        return sortedUsers.reduce((groups, user) => {
            const teamName = user.teamName || 'No Team';
            if (!groups[teamName]) {
                groups[teamName] = [];
            }
            groups[teamName].push(user);
            return groups;
        }, {} as Record<string, User[]>);
    });

    return { groupedAndSortedUsers };
}